import { Flex, Tag } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { BUDGET_STEPS, STAGES } from 'src/pages/budget/const'
import { PermissionList, User } from 'src/pages/budget/budgetTeams/types'

const stageColumns: ColumnsType<User> = STAGES.map((stage) => ({
  title: <>{BUDGET_STEPS[stage]}</>,
  onHeaderCell: () => ({
    className: 'resize_column',
  }),
  key: stage,
  dataIndex: stage,
  render: (items: PermissionList[]) => (
    <Flex wrap>
      {items.map((item) => (
        <Tag key={item.teamId} style={{ marginBottom: 4 }}>
          {item.teamName}
        </Tag>
      ))}
    </Flex>
  )

}))

export const columnsUserList: ColumnsType<User> = [
  {
    title: 'Сотрудник',
    dataIndex: 'fullName',
    key: 'fullName',
  },
  {
    title: 'Должность',
    dataIndex: 'position',
    key: 'position',
  },
  ...stageColumns,
]
